export enum MetricTypeEnum {
    Network = 0,
    Tunnel = 1,
}
